import * as React from "react";
import BPMButton from "./Button";
import { Item } from "devextreme-react/toolbar";

export type GroupByDateType = 'day' | 'month' | 'week'


export function GroupByDate(selected: GroupByDateType, onSelectionChanged: (selected: GroupByDateType) => void) {
    return [
        <Item location="after" key={'day'}
            locateInMenu="never"
            render={() => {
                return <BPMButton title={'day'} onClick={() => {
                    if (selected != 'day') {
                        onSelectionChanged('day')
                    }
                }} active={selected == 'day'} />
            }} />,
        <Item location="after" key={'week'}
            locateInMenu="never"
            render={() => {
                return <BPMButton title={'week'} onClick={() => {
                    if (selected != 'week') {
                        onSelectionChanged('week')
                    }
                }} active={selected == 'week'} />
            }} />,
        <Item location="after" key={'month'}
            locateInMenu="never"
            render={() => {
                return <BPMButton title={'month'} onClick={() => {
                    if (selected != 'month') {
                        onSelectionChanged('month')
                    }
                }} active={selected == 'month'} />
            }} />]
}


// WEBPACK FOOTER //
// ./src/components/GroupByDate.tsx